import React from "react";
import MerchantLayout from "../MerchantLayout";
import SettingsPage from "./page/SettingsPage";
import LoadPayments from "./page/LoadPayments";
import Customers from "./page/Customers";
import { Navigate } from "react-router-dom";
import Settlements from "./page/Settlements";

const MerchantRoutes = [
  {
    path: "/dashboard",
    element: <MerchantLayout />,
    children: [
      {
        index: true,
        element: <Navigate to="/dashboard/payments/load" replace />,
      },
      {
        path: "payments/load",
        element: <LoadPayments />,
      },
      {
        path: "settlements/load",
        element: <Settlements />,
      },
      {
        path: "customers",
        element: <Customers />,
      },
      {
        path: "settings",
        children: [
          {
            index: true,
            element: <SettingsPage />,
          },
        ],
      },
    ],
  },
];

export default MerchantRoutes;
